const onitUrl = "https://portalepaziente.korian.it/PrenotazioneIntegrata/Index";
const hideLoader = () => {
	const loopLoader = document.querySelector('.algolia-loop.--loading');
	if(loopLoader){
		loopLoader.classList.remove('--loading');
	}
}

// Flag per tenere traccia se l'elaborazione è stata completata
let elaborazioneCompletata = false;

const singleMedico = async () => {
	elaborazioneCompletata = false;  // Reset del flag all'inizio
	const onit_prenota_medico = document.querySelector(`.onit-prenota-medico`);
	if (medico_json && onit_prenota_medico) {
		var prestazioniMedico = [];
		const filtroCF = medico_json.codice_fiscale;
		
		const medico_form = document.querySelector(`.medico-form`);
		if (filtroCF !== '') {
			try {
				const response = await fetch(`/wp-json/proxy/v1/onit?endpoint=medici&tipofiltro=FiltroCF&filtro=${filtroCF}`);
				if (!response.ok) {
					const errorText = await response.text();
					console.error('Response error:', errorText);
					elaborazioneCompletata = true;  // Imposta il flag anche in caso di errore
					ordinaElementi();
					hideLoader();
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const data = await response.json();
				if (!data.Error) {
					const codiciInseriti = new Set();
					if (data.Medici.length > 0) {
						data.Medici.forEach((medico, index) => {
							var medicoPrenotabile = false;
							const pulsantiGiaAggiornati = new Set(); // Set per tracciare i pulsanti già aggiornati
							
							medico.Strutture.forEach(struttura => {
								struttura.Prestazioni
									.filter(prestazione => prestazione.PrenotabileWeb === "S")
									.forEach(prestazione => {
										if (!codiciInseriti.has(prestazione.Codice)) {
											medicoPrenotabile = true;
											prestazioniMedico.push(prestazione);
											codiciInseriti.add(prestazione.Codice);
										}
										
										// Aggiorna il pulsante solo se non è già stato aggiornato per questo medico
										const codice_onit = prestazione.Codice;
										if (!pulsantiGiaAggiornati.has(codice_onit)) {
											const onit_prenota_prestazione = document.querySelector(`.onit-prenota-prestazione[data-prestazione-code="${codice_onit}"]`);
											if (onit_prenota_prestazione) {
												onit_prenota_prestazione.classList.remove('d-none');
												onit_prenota_prestazione.href = onit_prenota_prestazione.href + medico.Codice;
												pulsantiGiaAggiornati.add(codice_onit); // Segna questo pulsante come aggiornato
											}
										}
									});
							});
							if (medicoPrenotabile) {
								onit_prenota_medico.href = onit_prenota_medico.href + medico.Codice;
								onit_prenota_medico.classList.remove('disabled');
								medico_form.classList.add('d-none');
							}else {
								onit_prenota_medico.href = '#pre--medico-prenotazione';
								onit_prenota_medico.target = '_self';
								onit_prenota_medico.innerHTML = 'Richiedi prenotazione'
								onit_prenota_medico.classList.remove('disabled');
							}
						});
					} else {
						onit_prenota_medico.href = '#pre--medico-prenotazione';
						onit_prenota_medico.target = '_self';
						onit_prenota_medico.innerHTML = 'Richiedi prenotazione'
						onit_prenota_medico.classList.remove('disabled');
					}
				}

				// Fine dell'elaborazione
				elaborazioneCompletata = true;
				ordinaElementi();
				hideLoader();

			} catch (error) {
				console.error('Fetch error details:', error);
				elaborazioneCompletata = true;  // Imposta il flag anche in caso di errore
				ordinaElementi();
				hideLoader();
			}
		} else {
			onit_prenota_medico.href = '#pre--medico-prenotazione';
			onit_prenota_medico.target = '_self';
			onit_prenota_medico.innerHTML = 'Richiedi prenotazione'
			onit_prenota_medico.classList.remove('disabled');
			
			// Fine dell'elaborazione anche in questo caso
			elaborazioneCompletata = true;
			ordinaElementi();
			hideLoader();
		}
	} else {
		// Se non c'è medico_json, segna comunque come completato
		elaborazioneCompletata = true;
		ordinaElementi();
		hideLoader();
	}
}

const singlePrestazione = async () => {
	if (prestazione_json) {
		var prestazione = false;
		const codice = prestazione_json.codice_onit;
		const codice_struttura = prestazione_json.codice_onit_struttura;
		const prenotazione_form = document.querySelectorAll(`.prenotazione-form`);
		const onit_prenotabile_struttura = document.querySelectorAll(`.onit-prenotabile`);
		if (codice !== '') {
			try {
				const response = await fetch(`/wp-json/proxy/v1/onit?endpoint=prestazioni&tipofiltro=Codice&filtro=${codice}`);

				if (!response.ok) {
					const errorText = await response.text();
					console.error('Response error:', errorText);
					throw new Error(`HTTP error! status: ${response.status}`);
				}

				const data = await response.json();
				if (!data.Error) {
					prestazione = data.Prestazione;

					if (prestazione.PrenotabileWeb === "S") {
						if (document.querySelector('.single-korian_performance') || document.querySelector('.banner-prenotazioni.--prestazione')) {
							const onit_prenotabile = document.querySelector(`.onit-prenota-prestazione`);
							onit_prenotabile.classList.remove('d-none');
							prenotazione_form.forEach(item => {
								item.classList.add('d-none');
							})
						} else {
							if (codice_struttura !== '' && prestazione.Strutture.some(struttura => struttura.Struttura.Codice === codice_struttura && struttura.MediciEroganti.length > 0)) {
								const onit_prenotabile = document.querySelector(`.onit-prenota-prestazione`);
								onit_prenotabile.classList.remove('d-none');
								prenotazione_form.forEach(item => {
									item.classList.add('d-none');
								})
							} else {
								const onit_prenotabile = document.querySelector(`.prenotazione-form`);
								onit_prenotabile.classList.remove('d-none');
								prenotazione_form.forEach(item => {
									item.classList.remove('d-none');
								})
							}
						}
					}
				}
			} catch (error) {
				console.error('Fetch error details:', error);
			}
		}
		if (codice == '' || codice_struttura == '') {
			onit_prenotabile_struttura.forEach(onit_prenotabile => {
				onit_prenotabile.classList.remove('d-none');
			})
		}
	}
}

const singleStruttura = async () => {
	elaborazioneCompletata = false;  // Reset del flag all'inizio
	const has_prestazioni_btn = document.querySelectorAll(`.onit-prenota-struttura[data-has-prestazioni="1"]`);
	var has_prestazioni = has_prestazioni_btn.length > 0 ? true : false;
	if (struttura_json) {
		var struttura = false;
		var prestazioni = false;
		const codice = struttura_json.codice_onit;
		const codice_prestazione = struttura_json.codice_onit_prestazione;
		const onit_prenotabile = document.querySelectorAll(`.onit-prenotabile`);
		if (codice !== '') {
			try {
				const response = await fetch(`/wp-json/proxy/v1/onit?endpoint=prestazioni&tipofiltro=CodStruttura&filtro=${codice}`);

				if (!response.ok) {
					const errorText = await response.text();
					console.error('Response error:', errorText);
					elaborazioneCompletata = true;  // Imposta il flag anche in caso di errore
					ordinaElementi();
					hideLoader();
					throw new Error(`HTTP error! status: ${response.status}`);
				}

				const data = await response.json();
				if (!data.Error) {
					prestazioni = data.Prestazioni;
					const mediciInseriti = new Set();

					// Creo un oggetto per salvare i dati puliti delle prestazioni
					const prestazioniPulite = {};
					// Creo un oggetto per salvare i dati puliti dei medici
					const mediciPuliti = {};

					if (prestazioni.length) {
						var structure_is_online = false;
						prestazioni.forEach(prestazione => {
							const codice_onit = prestazione.Codice;
							const onit_prenota_prestazione = document.querySelector(`.onit-prenota-prestazione[data-prestazione-code="${codice_onit}"]`);
							if (prestazione.Strutture.some(struttura => struttura.Struttura.Codice === codice && struttura.MediciEroganti.length > 0)) {
								structure_is_online = true;
								// Salvo i dati puliti della prestazione
								if (codice_onit) {
									prestazioniPulite[codice_onit] = {
										codice: codice_onit,
										nome: prestazione.Nome,
										prenotabile: prestazione.PrenotabileWeb === "S",
										url_prenotazione: onitUrl + "?IdPrestazioneGruppo=" + codice_onit + "&IdAziendaGruppo=" + codice
									};
								}

								if (onit_prenota_prestazione && prestazione.PrenotabileWeb === "S") {
									onit_prenota_prestazione.classList.remove('d-none');
									onit_prenota_prestazione.href = onit_prenota_prestazione.href + codice;
								}

								if (document.querySelector('.korian_structure-template-tpl-struttura-medici') && document.querySelector('.onit-prenota-link')) {
									// Troviamo la struttura corretta per accedere ai suoi medici
									const strutturaCorretta = prestazione.Strutture.find(s => s.Struttura.Codice === codice);
									if (strutturaCorretta && strutturaCorretta.MediciEroganti) {
										strutturaCorretta.MediciEroganti.forEach(medico => {
											if (medico.PrenotabileWeb === "S" && !mediciInseriti.has(medico.Codice)) {
												mediciInseriti.add(medico.Codice);
												const onit_cf = medico.CF;

												// Salvo i dati puliti del medico
												if (medico.Codice) {
													mediciPuliti[onit_cf] = {
														codice: medico.Codice,
														cf: medico.CF,
														nome: medico.Nome,
														prenotabile: medico.PrenotabileWeb === "S",
														url_prenotazione: onitUrl + "?IdMedicoGruppo=" + medico.Codice + "&IdAziendaGruppo=" + codice
													};
												}

												const onit_prenota_medico = document.querySelector(`.onit-prenota-link[data-onit-id="${onit_cf}"]`);
												if (onit_prenota_medico) {
													onit_prenota_medico.classList.remove('d-none');
													onit_prenota_medico.href = onit_prenota_medico.href + medico.Codice;
												}
											}
										});
									}
								}
							}
						});
						if(!structure_is_online){
							onit_prenotabile.forEach(onit_prenotabile => {
								onit_prenotabile.classList.remove('d-none');
								let onit_btn = onit_prenotabile.querySelector('a');
								if (onit_btn) {
									//data-bs-toggle="offcanvas"
									onit_btn.dataset.bsToggle = 'offcanvas';
									onit_btn.href = has_prestazioni ? '#prenotazioniRequest' : '#inforequest';
									onit_btn.target = '_self';
									onit_btn.innerHTML = has_prestazioni ? 'Richiedi prenotazione' : 'Richiedi informazioni'
								}
							})
						}
						// Espongo i dati come variabile globale per poterli utilizzare in algolia.js
						window.prestazioniPulite = prestazioniPulite;
						window.mediciPuliti = mediciPuliti;

						// Script per esporre le variabili globali
						const scriptElement = document.createElement('script');
						scriptElement.textContent = `
							window.prestazioniPulite = ${JSON.stringify(prestazioniPulite)};
							window.mediciPuliti = ${JSON.stringify(mediciPuliti)};
						`;
						document.head.appendChild(scriptElement);
					} else {
						onit_prenotabile.forEach(onit_prenotabile => {
							onit_prenotabile.classList.remove('d-none');
							let onit_btn = onit_prenotabile.querySelector('a');
							if (onit_btn) {
								//data-bs-toggle="offcanvas"
								onit_btn.dataset.bsToggle = 'offcanvas';
								onit_btn.href = has_prestazioni ? '#prenotazioniRequest' : '#inforequest';
								onit_btn.target = '_self';
								onit_btn.innerHTML = has_prestazioni ? 'Richiedi prenotazione' : 'Richiedi informazioni'
							}
						})
					}

				}

				// Fine dell'elaborazione
				elaborazioneCompletata = true;
				ordinaElementi();
				hideLoader();

			} catch (error) {
				console.error('Fetch error details:', error);
				elaborazioneCompletata = true;  // Imposta il flag anche in caso di errore
				ordinaElementi();
				hideLoader();
			}
		} else {
			onit_prenotabile.forEach(onit_prenotabile => {
				let onit_btn = onit_prenotabile.querySelector('a');
				if (onit_btn) {
					onit_btn.classList.remove('d-none');
					onit_btn.dataset.bsToggle = 'offcanvas';
					onit_btn.href = has_prestazioni ? '#prenotazioniRequest' : '#inforequest';
					onit_btn.target = '_self';
					onit_btn.innerHTML = has_prestazioni ? 'Richiedi prenotazione' : 'Richiedi informazioni'
				}
			})

			// Fine dell'elaborazione anche in questo caso
			elaborazioneCompletata = true;
			ordinaElementi();
			hideLoader();
		}
	} else {
		// Se non c'è struttura_json, segna comunque come completato
		elaborazioneCompletata = true;
		ordinaElementi();
		hideLoader();
	}
}

const OnitFetches = () => {
	
	if (document.querySelector('.single-korian_doctor') && typeof medico_json !== 'undefined') {
		singleMedico();
	}
	if ((document.querySelector('.single-korian_performance') || document.querySelector('.korian_structure-template') || document.querySelector('.banner-prenotazioni.--prestazione')) && typeof prestazione_json !== 'undefined') {
		singlePrestazione();
	}
	if (document.querySelector('.korian_structure-template') && typeof struttura_json !== 'undefined') {
		singleStruttura();
	}
}

/**
 * Funzione principale che esegue l'ordinamento
 */
function ordinaElementi() {
	// Non procedere se l'elaborazione dei dati non è stata completata
	if (!elaborazioneCompletata) {
		return;
	}

	// Ordina prestazioni se presenti
	ordinaPrestazioniPerPrenotabilita();

	// Ordina medici se presenti
	//ordinaMediciPerPrenotabilita();
}

/**
 * Ordina le prestazioni mostrando per prime quelle prenotabili
 */
function ordinaPrestazioniPerPrenotabilita() {
	// Selettore degli elementi da ordinare
	const elementiSelector = '.algolia-loop__item.--prestazione';

	// Selettore dei pulsanti di prenotazione
	const prenotaButtonSelector = '.onit-prenota-prestazione:not(.d-none)';

	// Esegue l'ordinamento con i selettori specifici per le prestazioni
	ordinaElementiPerPulsante(elementiSelector, prenotaButtonSelector);
}

/**
 * Ordina i medici mostrando per primi quelli prenotabili
 */
function ordinaMediciPerPrenotabilita() {
	// Selettore degli elementi da ordinare
	const elementiSelector = '.algolia-loop__item.--medico';

	// Selettore dei pulsanti di prenotazione (correzione della classe)
	const prenotaButtonSelector = '.onit-prenota-link:not(.d-none)';

	// Esegue l'ordinamento con i selettori specifici per i medici
	ordinaElementiPerPulsante(elementiSelector, prenotaButtonSelector);
}

/**
 * Funzione generale di ordinamento che accetta selettori specifici
 */
function ordinaElementiPerPulsante(elementiSelector, prenotaButtonSelector) {
	// Cerca il container dei risultati
	const container = document.querySelector('.algolia-loop__results');
	if (!container) return;

	// Cerca gli elementi da ordinare usando il selettore passato
	const elementi = container.querySelectorAll(elementiSelector);
	if (elementi.length === 0) return;

	// Converti in array per poter usare i metodi di array
	const elementiArray = Array.from(elementi);

	// Dividi in due gruppi: prenotabili e non prenotabili
	const prenotabili = [];
	const nonPrenotabili = [];

	// Classifica gli elementi in base alla presenza del pulsante di prenotazione
	elementiArray.forEach(elemento => {
		// Rimuovi eventuali classi --hidden esistenti
		elemento.classList.remove('--hidden');

		// Controlla se l'elemento ha un pulsante di prenotazione visibile
		if (elemento.querySelector(prenotaButtonSelector)) {
			prenotabili.push(elemento);
		} else {
			nonPrenotabili.push(elemento);
		}
	});

	// Se tutti gli elementi sono dello stesso tipo, aggiungi solo la classe --hidden dopo i primi 12
	if (prenotabili.length === 0 || nonPrenotabili.length === 0) {
		elementiArray.forEach((elemento, index) => {
			if (index >= 12) {
				elemento.classList.add('--hidden');
			}
		});
		return;
	}

	// Crea un array con gli elementi ordinati: prima i prenotabili, poi i non prenotabili
	const elementiOrdinati = [...prenotabili, ...nonPrenotabili];

	// Rimuovi gli elementi dal DOM per reinserirli nell'ordine corretto
	try {
		elementiArray.forEach(elemento => {
			container.removeChild(elemento);
		});

		// Reinserisci gli elementi nell'ordine corretto, aggiungendo la classe --hidden dopo i primi 12
		elementiOrdinati.forEach((elemento, index) => {
			if (index >= 12) {
				elemento.classList.add('--hidden');
			}
			container.appendChild(elemento);
		});
	} catch (error) {
		console.error("Errore durante l'ordinamento degli elementi:", error);
	}
}

export default OnitFetches;
